<template>
  <div class="contanierT">
    <div class="bottom">
      <div class="b1">
        <div class="b1-logo">
          <img :src="info.bottom_logo" alt="" />
          <div class="center1-left">
            <div class="center1-1">
              <div class="center1-wx">
                <img alt="" :src="info.wx_image" class="img" />
                <div class="title">{{ $t("home.WeChatOfficialAccount") }}</div>
              </div>
              <div class="center1-wb">
                <img alt="" :Src="info.wb_image" />
                <div class="title">{{ $t("home.MicroBlog") }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="b1-center1">
          <div class="center1-right">
            <div class="center1" v-if="menus[1]">
              <div class="title">{{ menus[1].title }}</div>
              <div
                class="title1"
                @click="toRoute(item.web_url)"
                v-for="(item,index) in menus[1].subs"
                :key="index"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="center2" v-if="menus[2]">
              <div class="title">{{ menus[2].title }}</div>
              <div
                class="title1"
                @click="toRoute(item.web_url)"
                v-for="(item,index) in menus[2].subs"
                :key="index"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="center2" v-if="menus[3]">
              <div class="title">{{ menus[3].title }}</div>
              <div
                class="title1"
                @click="toRoute(item.web_url)"
                v-for="(item,index) in menus[3].subs"
                :key="index"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="center2" v-if="menus[4]">
              <div class="title">{{ menus[4].title }}</div>
              <div
                class="title1"
                @click="toRoute(item.web_url)"
                v-for="(item,index) in menus[4].subs"
                :key="index"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="center2" v-if="menus[5]">
              <div class="title">{{ menus[5].title }}</div>
              <div
                class="title1"
                @click="toRoute(item.web_url)"
                v-for="(item,index) in menus[5].subs"
                :key="index"
              >
                {{ item.title }}
              </div>
            </div>
            <!-- <div class="center2" v-if="menus[6].title">
              <div class="title">{{ menus[6].title }}</div>
              <div
                class="title1"
                @click="toRoute(item.web_url)"
                v-for="item in menus[6].subs"
                 :key="item"
              >
                {{ item.title }}
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="b2">
        <div class="b1-center2">
          <div class="left-1">
            <div class="icon">
              <img :src="base('dw.png')" alt="" />
            </div>
            <div class="title">
              {{ $t("home.CompanyAddress") }}
            </div>
            <div class="title1">{{ info.address }}</div>
            <div class="title2">{{ info.company }}</div>
          </div>
          <div class="left-2">
            <div class="icon">
              <img :src="base('dh.png')" alt="" />
            </div>
            <div class="title">{{ $t("home.Telephone") }}: </div>
            <div class="title1">{{ info.phone }}</div>
          </div>
          <div class="left-3">
            <div class="icon">
              <img :src="base('yx.png')" alt="" />
            </div>
            <div class="title">{{ $t("home.mailbox") }}:  </div>
            <div class="title1"> {{ info.email }}</div>
          </div>
        </div>
      </div>

      <div class="b3">
        <div class="b1-l">
          <div class="b1-bottom">
            <div class="b1-title">{{ $t("home.Flinks") }}：</div>
            <div class="b1-comp">
              <div
                v-for="(item, index) in comp"
                :key="index"
                @click="toweb(item.url)"
                class="comp-title"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="b1-b">
        <div class="b1-bottom1" @click="ceshi">
          {{ info.filing_info }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { base_image } from "@/utils/baseImage";
import { Other, Menus } from "../api/home";

export default {
  name: "",
  data() {
    return {
      showee: false,
      info: {},
      show: true,
      menus: [],
      comp: [],
    };
  },
  created() {},
  mounted() {
    this.getOther();
    this.getMenus();
  },
  methods: {
    base(name) {
      return base_image("home", name);
    },
    ceshi() {
      this.$router.push("/hall");
    },

    async getOther() {
      const { data } = await Other();
      // console.log(data.data)
      this.info = data.data;
      this.comp = data.data.friends;
    },
    async getMenus() {
      const { data } = await Menus();
      // console.log(data.data, '---167---')
      this.menus = data.data;
    },
    toRoute(url) {
      this.$router.push(url);
    },
    toweb(url) {
      window.open(url, "_blank");
    },
    toSeek() {
      // this.$router.push('/my/seek?id=136')
      console.log();
      if (this.$route.path !== "/my/seek") {
        this.$router.push("/my/seek?id=136");
      } else {
        this.$confirm({
          content: "您已在当前页",
        });
      }
    },
    enterER() {
      this.showee = true;
    },
    leaveER() {
      this.showee = false;
    },
  },
};
</script>
<style scoped lang="scss">
.contanierT {
  // height: 1202px;
  padding-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  width: 100%;

  .bottom {
    // height: 100%;
    background: #fff;
    box-sizing: border-box;
    // padding-bottom: 70px;
    padding-top: 65px;
    display: flex;
    // justify-content: center;
    flex-wrap: wrap;
    padding-bottom: 30px;
    // border-top: 1px solid #333;

    .b1 {
      width: 1460px;
      margin-left: 231px;
      display: flex;
      margin-bottom: 10px;

      // flex-wrap: wrap;

      .b1-logo {
        width: 353px;
        // height: 47px;
        height: 248px;
        box-sizing: border-box;
        border-right: 1px solid #e0e0e0;

        img {
          width: 272px;
          height: 56px;
        }

        .center1-left {
          // width: 328px;
          // background-color: red;
          // height: 114px;
          display: flex;
          // padding-bottom: 120px;
          // box-sizing: border-box;

          .center1-1 {
            // width: 129px;
            // height: 292px;
            // background-color: blue;
            display: flex;
            // flex-wrap: wrap;
            margin-top: 20px;
            justify-content: space-between;
            .center1-wx {
              display: flex;
              justify-content: center;
              // flex-wrap: wrap;
              // width: 80px;
              width: 100%;
              flex-wrap: wrap;

              .title {
                width: 100%;
                height: 20px;
                font-family: PingFang SC;
                font-weight: 400;
                font-weight: bold;
                font-size: 14px;
                color: #666666;
                // padding-left: 2px;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                margin-top: 10px;
              }

              .img {
                width: 105px;
                height: 105px;
                margin-top: 14px;
              }
            }
            .center1-wb {
              margin-left: 20px;

              .title {
                width: 100%;
                height: 20px;
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                // padding-left: 2px;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                margin-top: 10px;
                font-weight: bold;
              }

              img {
                width: 105px;
                height: 105px;
                margin-top: 14px;
              }
            }
          }
        }
      }

      .b1-center1 {
        box-sizing: border-box;
        display: flex;

        .center1-right {
          // width: 1000px;
          // height: 403px;
          // background-color: blue;
          margin-left: 60px;
          display: flex;

          .center1 {
            width: 166px;
            // height: 403px;
            // background-color: red;

            .title {
              // width: 100px;
              // height: 28px;
              font-family: PingFang SC;
              font-weight: 600;
              font-size: 24px;
              color: #333333;
              display: flex;
              align-items: center;
              font-weight: bold;
            }

            .title1 {
              // height: 22px;
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #666;
              margin-top: 30px;
            }

            .title2 {
              // height: 22px;
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #999999;
              margin-top: 30px;
            }

            .title1:hover {
              color: green;
              cursor: pointer;
            }

            .title2:hover {
              color: green;
              cursor: pointer;
            }
          }

          .center2 {
            width: 166px;

            .title {
              // width: 100px;
              // height: 88px;
              font-family: PingFang SC;
              font-weight: 600;
              font-size: 24px;
              color: #333333;
            }

            .title1 {
              // height: 22px;
              font-family: PingFang SC;
              font-weight: 500;
              font-size: 18px;
              color: #666666;
              margin-top: 30px;
              // cursor: pointer;
            }

            .title2 {
              font-family: PingFang SC;
              font-weight: 500;
              font-size: 18px;
              color: #666666;
              margin-top: 30px;
              // cursor: pointer;
            }

            .title1:hover {
              color: green;
              cursor: pointer;
            }

            .title2:hover {
              color: green;
              cursor: pointer;
            }
          }
        }
      }
    }
    .b2 {
      width: 100%;
      display: flex;
      justify-content: center;
      // margin-bottom: 20px;
      .b1-center2 {
        // height: 200px;
        display: flex;
        // padding-top: 43px;
        flex-wrap: nowrap;
        width: 1570px;
        justify-content: center;
        border-bottom: 1px solid #e9e9e9;
        // padding-bottom: -60px;
        box-sizing: border-box;
        height: 84px;

        .left-1 {
          // width: 378px;
          // height: 145px;
          // background-color: red;
          display: flex;
          align-items: center;
          height: 84px;

          .icon {
            // height: 20px;
            margin-right: 8px;
            display: flex;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
              // background: #FFFFFF;
            }
          }

          .title {
            height: 28px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            // width: 70px;
            // margin-top: 20px;
            white-space: nowrap;
          }

          .title1 {
            // height: 22px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            white-space: nowrap;
            // margin-top: 10px;
          }

          .title2 {
            // height: 22px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            white-space: nowrap;
            // margin-top: 8px;
          }
        }

        .left-2 {
          // width: 127px;
          height: 84px;
          // background-color: #FFFFFF;
          margin-left: 80px;
          display: flex;
          align-items: center;

          .icon {
            // height: 20px;
            margin-right: 8px;
            display: flex;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
              // background: #FFFFFF;
            }
          }

          .title {
            // height: 28px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            white-space: nowrap;
            // width: 70px;
          }

          .title1 {
            // height: 22px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            white-space: nowrap;
            margin-left: 12px;
          }
        }

        .left-3 {
          // width: 166px;
          height: 84px;
          // background-color: aqua;
          margin-left: 120px;
          display: flex;
          align-items: center;

          .icon {
            // height: 20px;
            margin-right: 8px;
            display: flex;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
              // background: #FFFFFF;
            }
          }

          .title {
            height: 20px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            width: 42px;
            white-space: nowrap;
          }

          .title1 {
            height: 20px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            margin-left: 12px;
            white-space: nowrap;
          }
        }
      }
    }

    .b3 {
      width: 100%;
      display: flex;
      justify-content: center;
      .b1-l {
        display: flex;
        justify-content: center;
        width: 1570px;
        .b1-bottom {
          width: 100%;
          padding-top: 29px;
          box-sizing: border-box;
          display: flex;
          cursor: pointer;
          box-sizing: border-box;
          align-items: center;
          .b1-title {
            // width: 70px;
            // height: 20px;
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #333333;
          }

          .b1-comp {
            // width: 100%;
            display: flex;
            // justify-content: space-between;
            flex-wrap: wrap;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #666666;
            margin-left: 30px;

            .comp-title {
              margin-right: 20px;
              &:hover {
                color: #1eafa2;
              }
            }
          }
        }
      }
    }
  }

  .b1-b {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
    .b1-bottom1 {
      width: 534px;
      height: 60px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      text-align: center;
      background-color: #fff;
      // line-height: 57px;
      margin-top: 30px;
    }
  }
}
</style>
